<template>
  <div v-if="page" class="page">
    <page-banner
      :title="page.banner.title"
      :text="page.banner.text"
      :colour="page.banner.colour"
    />
    <div class="grid-x align-center">
      <div class="cell small-11 medium-10">
        <v-content :blocks="page.content"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import PageBanner from '@/components/PageBanner.vue';
  import VContent from '@/components/content/Content.vue';

  export default {
    components: {
      PageBanner,
      VContent
    },
    props: {
      homeSlug: String,
      slug: String
    },
    mounted() {
      this.fetchPage({slug: this.slug ?? this.$route.name, template: 'basic'})
        .then(() => {
        });
    },
    methods: {
      ...mapActions(['fetchPage']),
    },
    computed: {
      page() {
        return this.$store.getters.getPage(this.slug ?? this.$route.name);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
